module.exports = __webpack_public_path__ + "img/1297054669.8012350a.jpg";